var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useCallback, useMemo } from 'react';
import { ReadMoreContainer, ToggleButton } from './styles';
import Typography from '../typograhy';
import { DEFAULT_AMOUNT_OF_WORDS, DEFAULT_READ_MORE_LABEL, DEFAULT_READ_LESS_LABEL } from './constants';
var ReadMoreComponent = function (_a) {
    var text = _a.text, _b = _a.amountOfWords, amountOfWords = _b === void 0 ? DEFAULT_AMOUNT_OF_WORDS : _b, _c = _a.readMoreLabel, readMoreLabel = _c === void 0 ? DEFAULT_READ_MORE_LABEL : _c, _d = _a.readLessLabel, readLessLabel = _d === void 0 ? DEFAULT_READ_LESS_LABEL : _d, typographyProps = _a.typographyProps;
    var _e = useState(false), isExpanded = _e[0], setIsExpanded = _e[1];
    // Toggle expanded state
    var handleToggle = useCallback(function () {
        setIsExpanded(function (prev) { return !prev; });
    }, []);
    // Memoize words and truncation logic
    var _f = useMemo(function () {
        var words = text.split(' ');
        var shouldTruncate = words.length > amountOfWords;
        var displayedText = shouldTruncate && !isExpanded ? words.slice(0, amountOfWords).join(' ') + '...' : text;
        return { displayedText: displayedText, shouldTruncate: shouldTruncate };
    }, [text, amountOfWords, isExpanded]), displayedText = _f.displayedText, shouldTruncate = _f.shouldTruncate;
    return (React.createElement(ReadMoreContainer, null,
        React.createElement(Typography, __assign({}, typographyProps, { whiteSpace: "break-spaces" }),
            displayedText,
            shouldTruncate && (React.createElement(ToggleButton, { onClick: handleToggle },
                React.createElement(Typography, __assign({}, typographyProps, { textDecoration: "underline" }), isExpanded ? " " + readLessLabel : " " + readMoreLabel))))));
};
export default React.memo(ReadMoreComponent);
